import React from 'react';
import styled from 'styled-components';
import MemberList from './component/members/MemberList';
import MemberColumnInfo from './component/members/MemberColumnInfo';
import MemberDashboard from './component/members/MemberDashboard';
import FilterStationMember from './component/members/FilterStationMember';
import PageAboutMember from './component/members/PageAboutMember';



const AdminMembers: React.FC = () => {
  return (
    <>
      <MemberContainer>
        <MemberDashboard />
        <MemberColumnInfo />
        <MemberList />
        <FilterStationMember />
        <PageAboutMember />
      </MemberContainer>
    </>
  )
}

const MemberContainer = styled.main`
  width: 96%;
  height: 100vh;
  display: flex;
  flex-direction: column;
  margin-top: calc(7vh);
  margin-bottom: 5.8vh ;
  overflow: hidden;
`;

export default AdminMembers;
